// extracted by mini-css-extract-plugin
export default {"box":"PjT2hGeBH2P7EAy33yOu","textBox":"qmqlU3GaCs6XPH6zbWYj","titleBox":"qNjbNJnIkt9uD8PCYF1F","title":"XtLXULxYf4FYOpLuGjlb","description":"_z0nEyqmIErc2pFUiWHa"};